export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency : "INR",
    style: "currency",
    minimumFractionDigits: 0
})